<template>
  <footer class="footer">
    <section class="footer__top row -mobile -align-end">
      <img :src="$wp.logo.footer" class="footer__logo" />

      <p v-for="(info, icon) in $wp.contact" :key="icon" class="footer__info">
        <Icon :id="icon" />
        {{ info }}
      </p>

      <ul class="footer__social">
        <a
          v-for="(url, icon) in $wp.social"
          :key="icon"
          :href="url"
          target="_blank"
          rel="noopener"
          class="footer__link"
        >
          <Icon :id="icon" />
        </a>
      </ul>
    </section>

    <h6 class="footer__legal">
      &copy; {{ year }} {{ $wp.footerCopyright[this.$lang.current].trim() }}
      <span class="footer__credit">
        Site développé par <a href="https://boitebeet.com" target="_blank" rel="noopener">Beet</a>
      </span>
    </h6>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  contentKey: 'settings',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>
